import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createStore, Store } from 'effector';
import { RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import {
	AccountWithWalletsAndPermissions,
	accountWithWalletsAndPermissionsSchema,
	createPaginatedSchema,
} from '../types';

export type OriginalAccountRegistryParams = {
	sortField?: string | null;
	sortDirection?: string;
	page?: number;
	limit?: number;
	name?: string;
	currencies?: string[];
	accountId?: number;
};

export type AccountRegistryFilters = {
	name: string;
	currencies: string[];
};

export type AccountRegistryParams = RegistryParams<AccountRegistryFilters>;

export type AccountRegistryQuery = RegistryQuery<
	AccountWithWalletsAndPermissions,
	AccountRegistryFilters,
	JsonApiRequestError
>;

export const createAccountRegistryQuery = (
	$accountId?: Store<number | null>,
): AccountRegistryQuery => {
	const query = createAuthQuery({
		params: declareParams<AccountRegistryParams>(),
		request: {
			method: 'GET',
			url: '/account/list',
			query: {
				source: $accountId ?? createStore(null),
				fn: (params, accountId) => ({
					page: params.page,
					limit: params.limit,
					sortField: params.sortField ?? undefined,
					sortDirection: params.sortDirection,
					name: params.filters.name ?? undefined,
					currencies:
						params.filters.currencies?.length === 0 ? undefined : params.filters.currencies,
					accountId: accountId ?? undefined,
				}),
			},
		},
		response: {
			contract: zodContract(createPaginatedSchema(accountWithWalletsAndPermissionsSchema)),
		},
	});

	return query;
};
